/**
 * Easely Config - Expanded Professional Presets
 */

export const CONFIG = {
  VERSION: '1.0.0',
  PREFIX: 'data-ez',
  TL_PREFIX: 'data-ez-tl',
  INIT_ATTR: 'data-ez-id',
  DEFAULT_DURATION: 0.8,
  DEFAULT_EASE: 'expo.out', // Upgraded to 'expo' for a more professional feel
  SAFE_MODE: true,
};

export const PRESETS = {
  // --- Standard ---
  'fade': { opacity: 0 },
  
  // --- Directional (Slide) ---
  'slide-up': { y: 60, opacity: 0 },
  'slide-down': { y: -60, opacity: 0 },
  'slide-left': { x: 60, opacity: 0 },
  'slide-right': { x: -60, opacity: 0 },

  // --- Scale & Zoom ---
  'zoom-in': { scale: 0.7, opacity: 0 },
  'zoom-out': { scale: 1.3, opacity: 0 },

  // --- Professional / Boutique ---
  'blur-in': { filter: 'blur(10px)', opacity: 0 },
  'blur-up': { y: 40, filter: 'blur(10px)', opacity: 0 },
  
  // --- 3D Effects ---
  'rotate-in': { rotationX: -30, opacity: 0, transformOrigin: 'center top' },
  'flip-up': { rotationX: 90, opacity: 0, transformOrigin: 'center center' },
  
  // --- Creative / Playful ---
  'back-in': { scale: 0.5, opacity: 0, ease: 'back.out(1.7)' }
};